import {
  ManualAccount,
  PlaidAccount,
} from "@fartherfinance/frontend/api/ExternalAccount/requests/getExternalAccounts";

export const getExternalAccountBalance = (
  exAcct: PlaidAccount | ManualAccount
): number | undefined => {
  if (exAcct.accountProvider === "plaid") {
    return (
      exAcct.details.account.currentBalance ??
      exAcct.details.account.availableBalance ??
      undefined
    );
  }

  return undefined;
};
